import { useState } from 'react';
import { AText, Box, Button } from '@alf/uikit';
import { LOG_ACTIONS, logAction } from '@namespace/analytics';
import { Close } from '@namespace/common';
import { COOKIES_KEYS, setCookie } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { nativeAppActions } from '../../store/actions';

import styles from './index.module.css';

type componentType = 'menu' | 'notification';

interface DownloadPWABannerProps {
  action?: () => void;
  containerCustomClass?: string;
  withClose?: boolean;
  type?: componentType;
}

export const DownloadPWABanner = ({
  action,
  containerCustomClass = '',
  withClose = true,
  type = 'notification'
}: DownloadPWABannerProps) => {
  const { t } = useI18n();
  const { SET_PWA_INSTRUCTIONS } = nativeAppActions;

  const [visible, setVisible] = useState(true);

  const onClick = () => {
    logAction(LOG_ACTIONS.PWA_DOWNLOAD_BANNER_CLICK);

    if (action) {
      action();
    }

    if (window.deferredPrompt) {
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          logAction(LOG_ACTIONS.PWA_PROMPT_ACCEPTED);
        } else {
          logAction(LOG_ACTIONS.PWA_PROMPT_DECLINED);
        }
      });
    } else {
      SET_PWA_INSTRUCTIONS(true);
    }
  };

  const onCloseHandler = () => {
    setCookie(COOKIES_KEYS.IS_MOBILE_PWA_BANNER_DISABLED, 'true');
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Box
      align="center"
      data-role="pwa-instructions-link"
      className={`${styles.instructionsContainer} ${containerCustomClass}`}
    >
      <Box flex="1" gap="s">
        {withClose && (
          <Close onClose={onCloseHandler} className={styles.newCloseBtn} />
        )}
        <Box className={styles.logoContainer}>
          <img src="/images/logo/logoSmall.svg" alt="" />
        </Box>
        <Box direction="column" justify="between">
          <AText breed="BU" size="s" transform="uppercase">
            {t(`web.pwa.${type}.title`)}
          </AText>
          <AText size="xs">{t(`web.pwa.${type}.subtitle`)}</AText>
        </Box>
      </Box>
      <Box className={styles.instructionsButtonContainer}>
        <Button size="m" onClick={onClick}>
          {t(`web.pwa.${type}.button`)}
        </Button>
      </Box>
    </Box>
  );
};
